export enum ResponseReaction {
  SLOW = "SLOW",
  MEDIUM = "MEDIUM",
  FAST = "FAST",
}

export enum PlatformActivityTypes {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum Platform {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
}

export type StoreDetail = {
  id: number;
  name: string;
  description: string;
  url: string;
  mainImage: string;
  images: StoreImage[];
  likes: string;
  reviewRate: number;
  hasDelivery: boolean;
  answerSpeed: ResponseReaction;
  activity: PlatformActivityTypes;
  website: string;
  country: string;
  state: string;
  subCategory: string;
  category: string;
  categorySlug: string;
  slug: string;
  nameChanges: NameChanges[];
  otherAddresses: OtherAddresses[];
  deleted: boolean;
  updatedAt: Date;
  plan: string;
};

export type StoreReviews = {
  avgCustomerService: number;
  avgGeneralReview: number;
  avgProductImageReview: number;
  totalReviews: number;
};

export type StoreImage = {
  original: string;
  thumbnail: string;
  loading: string;
};

export type NameChanges = {
  logo: string;
  name: string;
  year: number;
  month: number;
};
export enum offerCardType {
  GENERIC = "GENERIC", // Used in category pages
  STORE_SPECIFIC = "STORE_SPECIFIC", // Used in store detail pages
  OFFERS = "OFFERS", // Used in offers page
}

export type OtherAddresses = {
  address: string;
  subAddress: string;
  mapEmbedUrl: string;
};
